import React from 'react';
import PropTypes from 'prop-types';

import Money from '../../../components/Money';

const OrderInformation = ({ gcAmount }) => (
  <div>
    <div className="c-heading c-heading--huge u-mb u-pt-- u-show-for-large-and-up">Order Information</div>
    <div className="c-heading c-heading--huge u-mb- u-text-center u-hide-for-large-and-up">Order Information</div>
    <div className="c-order-info">
      <div className="c-order-info__desc">
        <div className="u-inline-block">
          Gift Card:
        </div>
      </div>
      <div className="c-order-info__price">
        <Money>{gcAmount}</Money>
      </div>
      <hr className="c-separator u-mt u-mb- c-order-info__separator" />
      <div className="u-pt-- u-co-black-2">
        <div className="c-order-info__desc">Total:</div>
        <div className="c-order-info__price">
          <Money>{gcAmount}</Money>
        </div>
      </div>
    </div>
  </div>
);

OrderInformation.propTypes = {
  gcAmount: PropTypes.number.isRequired,
};

export default OrderInformation;



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/OrderInformation/OrderInformation.jsx